import Box from '@mui/material/Box';
import { SectionTitle, Subsection } from '../components/SectionPrimitives';

export function Section7(): JSX.Element {
  return (
    <Box>
      <SectionTitle>7. Service Availability and Platform Changes</SectionTitle>

      <Subsection title="7.1 Availability">
        UKVG shall use reasonable endeavours to ensure that the platform remains
        accessible to end users and Partners during the agreement period. UKVG
        does not guarantee uninterrupted or error-free access and shall not be
        liable for temporary unavailability arising from scheduled maintenance,
        third-party infrastructure failures, telecommunications outages, force
        majeure events, or updates and technical improvements to the platform.
      </Subsection>

      <Subsection title="7.2 Platform Changes">
        UKVG reserves the right to update, modify, or discontinue features of
        the platform at any time. Where a material change would significantly
        reduce the services included in the Partner's agreement tier, UKVG shall
        provide no less than 30 days' written notice. In such circumstances, the
        Partner may cancel the agreement and receive a pro-rata refund of any
        prepaid fees for the unexpired portion of the term.
      </Subsection>

      <Subsection title="7.3 Content Publication">
        UKVG shall use reasonable endeavours to publish Partner content
        accurately and in accordance with the agreed service tier. The Partner
        acknowledges that editorial adjustments may be made for formatting,
        clarity, or platform consistency.
      </Subsection>
    </Box>
  );
}
